import React from "react";
import { Link } from "react-router-dom";
// Icons
import { Close, Menu, Phone } from "@mui/icons-material";
// Styles
import theme from "assets/theme";
// Components
import LoginAndLogOut from "components/CBLoginLogOut";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import { Stack, Typography } from "@mui/material";
// Utils
import { ghlLinkFreeConsultation } from "utils/helpers/ghlFunnelLinks";
import useMediaQueries from "utils/mediaQueries.utils";
import ShoppingCart from "components/CBShoppingCart";

const PhoneElement = () => {
  return (
    <MKBox
      component="a"
      href="tel:720-741-7205"
      sx={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        color: theme.palette.secondary.main,
        transition: "opacity 0.3s ease",
        "&:hover": {
          opacity: 0.8,
        },
      }}
      aria-label="Call Almadelic at 720-741-7205"
    >
      <Phone
        sx={{
          fontSize: { xs: "1rem", md: "1.25rem" },
          marginRight: "0.25rem",
        }}
        aria-hidden="true"
      />
      <Typography
        variant="button"
        sx={{
          fontSize: { xs: "0.75rem", md: "0.875rem" },
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        720-741-7205
      </Typography>
    </MKBox>
  );
};

const NavBarActions = ({ setMobileNavToggle, mobileNavToggle }) => {
  const toggleMobileNav = () => setMobileNavToggle(!mobileNavToggle);
  const { isMd, isNavMenu } = useMediaQueries();

  return (
    <Stack direction={"row"} alignItems={"center"} gap={isMd ? "1rem" : "0"}>
      {/* <Stack direction={isLg ? "row" : "column"} alignItems={"center"} gap={1}> */}
      {isMd && <ShoppingCart />}
      {/* Phone Number */}
      {isMd && <PhoneElement />}
      <Stack gap={1}>
        <MKButton
          component={Link}
          to={ghlLinkFreeConsultation}
          variant={"contained"}
          size="small"
          target="_blank"
          rel="noopener noreferrer"
          color="secondary"
          sx={{
            height: "1rem",
            width: { xs: "115px", md: "100%" },
            // marginInline: { md: "1rem" },
            padding: { xs: "0.5rem", md: ".375rem 1rem" },
            marginTop: { xs: "1.5rem", md: "0" },
          }}
          aria-label="Get Started Today"
        >
          Get Started
        </MKButton>
        {!isMd && <PhoneElement />}
      </Stack>
      {/* </Stack> */}
      {!isNavMenu && <LoginAndLogOut />}
      {isNavMenu && (
        <MKBox
          component={MKButton}
          display={{ xs: "inline-block", padding: "10px", minWidth: "40px !important" }}
          lineHeight={0}
          size="small"
          color={"#000"}
          sx={{ cursor: "pointer" }}
          onClick={toggleMobileNav}
          aria-label={mobileNavToggle ? "Close mobile navigation" : "Open mobile navigation"}
          aria-expanded={mobileNavToggle}
        >
          {mobileNavToggle ? (
            <Close
              role="img"
              aria-label="Close menu"
              sx={{ color: theme.palette.secondary.main, height: "24px", width: "24px" }}
              aria-hidden="false"
            />
          ) : (
            <Menu role="img" aria-label="Open menu" sx={{ color: theme.palette.secondary.main, height: "24px", width: "24px" }} aria-hidden="false" />
          )}
        </MKBox>
      )}
    </Stack>
  );
};

export default NavBarActions;
